<ul class="list-group" style="width: 200px; min-height: 40px; cursor: pointer">
  @if (contextMenuService.clickInfo.button == 'rightClick') {
    <li class="list-group-item d-flex d-grid gap-2 align-items-center fw-bold" (click)="copyPosition()">
      {{displayCoordinate(coordinates)}}
      <i class="fa fa-copy ms-auto"></i>
    </li>
  }

  @if (clipboardCoordinates?.length > 0 && contextMenuService.clickInfo.button == 'rightClick') {
    <li class="list-group-item d-flex d-grid gap-2 align-items-start text-muted">
      <div class="d-flex flex-column">
        @for (coordinate of clipboardCoordinates; track coordinate) {
          <div>
            {{displayCoordinate(coordinate)}}
          </div>
        }
      </div>
      <a class="ms-auto text-danger" (click)="clear()">
        <i class="fa fa-trash"></i>
      </a>
    </li>
  }

  @if (overlappingMarkers?.length > 1) {
    <li class="list-group-item d-flex d-grid gap-2 align-items-start text-muted">
      <div class="d-flex flex-column">
        @for (marker of overlappingMarkers; track marker) {
          <div class="fw-bold" (click)="focus(marker)">
            {{marker.name}}
          </div>
        }
      </div>
    </li>
  }

</ul>